export const ADD_STATUS = 'statuses/ADD_STATUS';
export const UPDATE_STATUS = 'statuses/UPDATE_STATUS';
export const DELETE_STATUS = 'statuses/DELETE_STATUS';
export const LOAD_STATUSES = 'statuses/LOAD_STATUSES';
